/**
 * Hybrid Banner Component
 * Automatically chooses between Tailwind and styled-components based on props.
 */

import * as React from "react";
import Box from "@sproutsocial/seeds-react-box";
import Button from "@sproutsocial/seeds-react-button";
import Icon from "@sproutsocial/seeds-react-icon";
import Container, { StyledBannerIcon } from "./styles"; // Styled-components version
import BannerTailwind from "./BannerTailwind"; // Tailwind version
import { getBannerIconName, getBannerIconColor } from "./bannerIcon";
import { hasStyledProps } from "@sproutsocial/seeds-react-system-props";
import type { TypeBannerProps } from "./BannerTypes";

/** TODO: change to 'info' type by default in future version */
const BannerHybrid = ({
  type = "info",
  variant = "default",
  text,
  onClose,
  closeButtonLabel = "Close",
  typeIconProps,
  ...rest
}: TypeBannerProps) => {
  if (hasStyledProps(rest)) {
    return (
      <Container
        type={type}
        variant={variant}
        data-qa-alert=""
        data-qa-alert-type={type}
        data-qa-alert-text={text}
        {...rest}
      >
        <Box display="flex" alignItems="center" width={1}>
          <StyledBannerIcon
            name={getBannerIconName(type)}
            color={getBannerIconColor(type, variant)}
            className="Icon"
            fixedWidth
            mt={100}
            mr={350}
            {...typeIconProps}
          />
          {text}
          {onClose && (
            <Box ml="auto" pl={400} alignSelf="flex-start">
              <Button p={0} onClick={onClose} ariaLabel={closeButtonLabel}>
                <Icon name="x-outline" aria-hidden />
              </Button>
            </Box>
          )}
        </Box>
      </Container>
    );
  }

  // Use Tailwind version (preferred - better performance)
  return (
    <BannerTailwind
      type={type}
      variant={variant}
      text={text}
      onClose={onClose}
      closeButtonLabel={closeButtonLabel}
      typeIconProps={typeIconProps}
      {...rest}
    />
  );
};

export default BannerHybrid;
